export * from "./API";
export * from "./string";
export * from "./parse";
export * from "./cookie";
export * from "./filter";
export * from "./json";
export * from "./url";
export * from "./data";
export * from "./products";
export * from "./offers";
export * from "./csv";
export * from "./dataUtils";
export * from "./datetime"
export * from "./indexedDB";
export * from "./schemas"

// Standardize offer and incentive text for decimal places, dollar signs, percentages, etc.
export const standardizeText = (text) => {
  if (typeof text !== "string") return text;

  // Remove commas from numbers
  const removeCommas = (str) => str.replace(/,/g, "");
  // Format number to two decimal places
  const formatNumber = (str) => {
    const num = parseFloat(removeCommas(str));
    return Number.isNaN(num) ? str : num.toFixed(2);
  };

  let result = text;

  // Handle dollar ranges, e.g. "$10-12", "$10 - $12", "$.5-1", "$2-$5", "$1,000 - 2,000"
  result = result.replace(
    /\$\s*([0-9,]*\.?[0-9]+)\s*-\s*(\$)?\s*([0-9,]*\.?[0-9]+)/g,
    (match, left, rightHasDollar, right) => {
      const leftFormatted = `$${formatNumber(left)}`;
      const rightFormatted = formatNumber(right);
      return `${leftFormatted}-${rightHasDollar ? "$" : ""}${rightFormatted}`;
    }
  );

  // Handle single dollar amounts, e.g. "$1", "$.5", "$1,000.5"
  result = result.replace(/\$\s*([0-9,]*\.?[0-9]+)/g, (match, num) => {
    return `$${formatNumber(num)}`;
  });

  // Handle cases like "$ Coupons 20" or "$ Coupons .2"
  result = result.replace(
    /(\$(?=[^\d]*[A-Za-z])[^\d]*?\s+)([0-9,]*\.?[0-9]+)\b/g,
    (match, prefix, num) => `${prefix}${formatNumber(num)}`
  );

  // Convert percentages to integer, e.g. "10.00%" -> "10%"
  result = result.replace(/(\d+)(?:\.\d+)?%/g, "$1%");

  //Trim whitespace
  result = result.trim();

  return result;
};
